import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_EXPORT_CLAIMS } from "../../action-types/actions";

export const exportClaims = createAsyncThunk(
  ACTIONS_EXPORT_CLAIMS.exportClaims,
  async ({ claim_type, filters }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.claimsexport}`,
        {
          claim_type,
          filters,
        },
      );

      if (response?.data?.status === true || response?.status === 200) {
        toast.success("Claims exported successfully");
        return response.data;
      } else {
        toast.error(response?.data?.message || "Failed to export claims");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Export claims error:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while exporting claims";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
